import React, { JSX } from 'react';
import { Td, Text, Tooltip, VStack } from '@chakra-ui/react';

import { useTranslations } from '../../../contexts/LocalizationContext';
import { formatNumber, formatWoWChange, isAlert, NormalizedThreshold } from '../utils/metrics';

interface Props {
  value: number;
  threshold: NormalizedThreshold;
  change: number | null;
}

const MetricValueCell = ({ value, threshold, change }: Props): JSX.Element => {
  const translations = useTranslations();
  const alert = isAlert(threshold, value);

  const valueNode = <Text as="span">{formatNumber(value)}</Text>;

  return (
    <Td
      textAlign="center"
      color={alert ? 'red.500' : undefined}
      fontWeight={alert ? 'bold' : undefined}
      sx={{ fontVariantNumeric: 'tabular-nums' }}
    >
      <VStack spacing={0} align="center">
        {alert ? (
          <Tooltip
            label={translations('monitoring_threshold_range', {
              '{{min}}': formatNumber(threshold.thresholdDown),
              '{{max}}': formatNumber(threshold.thresholdUp),
            })}
            hasArrow
          >
            {valueNode}
          </Tooltip>
        ) : (
          valueNode
        )}
        {change !== null && (
          <Text fontSize="xs" color="grey.200" fontWeight="normal">
            {formatWoWChange(change)}
          </Text>
        )}
      </VStack>
    </Td>
  );
};

export default MetricValueCell;
